// extracted by mini-css-extract-plugin
module.exports = {"content":"Overlay_content__1MOOO","icon":"Overlay_icon__2q5BH"};